import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

export class DateValidator {
  public static FutureDateTime: ValidatorFn = (control: AbstractControl<DateTime | null>): ValidationErrors | null => {
    const date = control.value;

    if (!date) {
      return null;
    }

    const now = DateTime.now();

    if (!date.isValid) {
      return { invalid: 'validation.datetime.invalid' };
    }

    return date > now ? null : { pastTime: 'validation.datetime.past-time' };
  };

  public static ValidDate: ValidatorFn = (control: AbstractControl<DateTime | null>): ValidationErrors | null => {
    const date = control.value;

    if (!date) {
      return null;
    }

    if (!date.isValid) {
      return { invalid: 'validation.datetime.invalid' };
    }

    return null;
  };
}
